import { render, staticRenderFns } from "./DomainAuthPanel.vue?vue&type=template&id=48725cc8"
import script from "./DomainAuthPanel.vue?vue&type=script&lang=js"
export * from "./DomainAuthPanel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports